import {useLocation, useParams} from "react-router-dom";
import Landing from "./Landing";
import {loadLanding} from "../../api/landing";
import {useQuery} from "@tanstack/react-query";

type QueryDataParams = {
    landingId: string
}

export default function LandingByRoute()
{
    const queryData = useParams<QueryDataParams>()
    const location = useLocation()

    const {data, status, error} = useQuery({
        queryKey: [...['landing'], [location.pathname], queryData],
        queryFn: () => loadLanding(queryData.landingId || '')
    })

    return ( <>
    <main className="landing-page">
    {data?.items?.length  && <div className="landing"><Landing landingItems={data.items} error={error ? error.name + error.message : ''} /></div>}
    </main>
    </>)
}